module.exports = __webpack_public_path__ + "img/equitativos-icon.f2baef81.svg";